export const selfDescriptionsSk = {
  selfDescriptions: {
    'Motivator': 'Motivátor',
    'Team Player': 'Tímový hráč',
    'Analysis': 'Analytik',
    'Solo Player': 'Individualista'
  }
};